import React, { useState } from 'react';
import AmlFormSC, { AmlFormTextInputSC, AmlFormErrorSC } from './aml-form.styled';
import { Formik } from 'formik';
import AMLFormRules from './aml-form-rules';
import { BodyText } from '../../typography';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import Button from '../../ui/button';
import SmallText from '../../typography/small-text';
import Checkbox from '../../ui/checkbox/checkbox';
import finalConsumerPdf from '../../../assets/pdf/KUV.pdf';
import politicallyExposedPdf from '../../../assets/pdf/PEO.pdf';
import sanctionedPdf from '../../../assets/pdf/SO.pdf';
import WishmakerModal from '../../ui/modal/modal';
import SureModal from './sure-modal';
import Tooltip from '../../ui/tooltip/tooltip';

const AmlForm = ({ onSubmitForm }) => {
  const [isSureModalOpened, setIsSureModalOpened] = useState(false);
  const [modalValues, setModalValues] = useState({});
  const formInitialValues = {
    total_amount: null,
    max_investment: null,
    reinvest_rate: 100,
    reinvest_agreement: true,
    /*  consent_to_repurchase_of_receivables: false, */
    final_consumer: false,
    politically_exposed: false,
    sanctioned: false,
    own_interest: false,
    the_purpose_is_to_enhance_funding: false,
    the_funds_do_not_come_from_illegal_sources: false,
    agreed_terms: false,
    agreement_with_the_fee_schedule: false,
    the_purpose_is_to_enhance_funding_additional_info: '',
  };

  const onSureModalSubmit = () => {
    const formattedValues = {
      ...modalValues,
      politically_exposed: modalValues.politically_exposed === true ? false : true,
      sanctioned: modalValues.sanctioned === true ? false : true,
      the_purpose_is_to_enhance_funding_additional_info:
        modalValues.the_purpose_is_to_enhance_funding === true
          ? ''
          : modalValues.the_purpose_is_to_enhance_funding_additional_info,
    };
    onSubmitForm(formattedValues);
    setIsSureModalOpened(false);
  };

  return (
    <>
      <WishmakerModal
        withCross
        isOpened={isSureModalOpened}
        className="special"
        onClose={() => setIsSureModalOpened(false)}
      >
        <SureModal
          values={modalValues}
          onClose={() => setIsSureModalOpened(false)}
          onSubmit={() => onSureModalSubmit()}
        />
      </WishmakerModal>

      <AmlFormSC>
        <Formik
          enableReinitialize
          initialValues={formInitialValues}
          validationSchema={AMLFormRules}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            const formattedValues = {
              ...values,
              politically_exposed: values.politically_exposed === true ? false : true,
              sanctioned: values.sanctioned === true ? false : true,
              the_purpose_is_to_enhance_funding_additional_info:
                values.the_purpose_is_to_enhance_funding === true
                  ? ''
                  : values.the_purpose_is_to_enhance_funding_additional_info,
            };
            if (
              values.the_purpose_is_to_enhance_funding === false ||
              values.own_interest === false ||
              values.sanctioned === false ||
              values.politically_exposed === false ||
              values.final_consumer === false
            ) {
              setIsSureModalOpened(true);
              setModalValues(values);
            } else {
              onSubmitForm(formattedValues);
            }
          }}
        >
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => {
            const totalAmountHasError = errors && errors.total_amount && touched.total_amount;
            const reinvestAgreementHasError =
              errors && errors.reinvest_agreement && touched.reinvest_agreement;
            const reinvestRateHasError = errors && errors.reinvest_rate && touched.reinvest_rate;

            /*  const repurchaseAgreementHasError =
            errors &&
            errors.consent_to_repurchase_of_receivables &&
            touched.consent_to_repurchase_of_receivables; */
            const maxInvestmentHasError = errors && errors.max_investment && touched.max_investment;

            const finalConsumerHasError = errors && errors.final_consumer && touched.final_consumer;
            const politicallyExposedHasError =
              errors && errors.politically_exposed && touched.politically_exposed;
            const sanctionedHasError = errors && errors.sanctioned && touched.sanctioned;

            const ownInterestHasError = errors && errors.own_interest && touched.own_interest;

            const enhanceFundingHasError =
              errors &&
              errors.the_purpose_is_to_enhance_funding &&
              touched.the_purpose_is_to_enhance_funding;

            const illegalSourcesHasError =
              errors &&
              errors.the_funds_do_not_come_from_illegal_sources &&
              touched.the_funds_do_not_come_from_illegal_sources;

            const agreedTermsHasError = errors && errors.agreed_terms && touched.agreed_terms;

            const agreementWithFeeScheduleHasError =
              errors &&
              errors.agreement_with_the_fee_schedule &&
              touched.agreement_with_the_fee_schedule;

            const purposeEnhanceHasError =
              errors &&
              errors.the_purpose_is_to_enhance_funding_additional_info &&
              touched.the_purpose_is_to_enhance_funding_additional_info;

            return (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="heading-block">
                    <BodyText className="bolder">
                      <FormattedMessage
                        id="onboarding_aml_form_headline_1"
                        defaultMessage={dlt['onboarding_aml_form_headline_1']}
                      />
                    </BodyText>
                    <div className="separator"></div>
                  </div>
                  <div className="full-block">
                    <SmallText className="smaller bolder input-label with-tooltip">
                      <FormattedMessage
                        id="onboarding_aml_form_max_amount_label"
                        defaultMessage={dlt['onboarding_aml_form_max_amount_label']}
                      />
                      <Tooltip
                        id="aml_max_amount_tooltip"
                        contentId="onboarding_aml_form_max_amount_tooltip"
                      />
                    </SmallText>

                    <FormattedMessage
                      id="onboarding_aml_form_max_amount_placeholder"
                      defaultMessage={dlt['onboarding_aml_form_max_amount_placeholder']}
                    >
                      {(placeholder) => (
                        <AmlFormTextInputSC
                          type="number"
                          name="total_amount"
                          placeholder={placeholder}
                          filled={values.total_amount}
                          hasError={totalAmountHasError}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.total_amount || ''}
                        />
                      )}
                    </FormattedMessage>
                    {totalAmountHasError ? (
                      <AmlFormErrorSC>{errors.total_amount}</AmlFormErrorSC>
                    ) : null}
                  </div>
                </div>
                <div className="row">
                  <div className="heading-block">
                    <BodyText className="bolder">
                      <FormattedMessage
                        id="onboarding_aml_form_headline_2"
                        defaultMessage={dlt['onboarding_aml_form_headline_2']}
                      />
                    </BodyText>
                    <div className="separator"></div>
                  </div>
                  <div>
                    <Checkbox
                      name="reinvest_agreement"
                      hasError={reinvestAgreementHasError}
                      value={`${values.reinvest_agreement}`}
                      checked={values.reinvest_agreement || false}
                      onChange={handleChange}
                      label="onboarding_aml_form_reinvest_agreement_label"
                      tooltipId="reinvest_tooltip"
                      tooltipContentId="onboarding_aml_form_reinvest_agreement_label_tooltip"
                      tooltipMinWidth="335px"
                    />
                    {reinvestAgreementHasError ? (
                      <AmlFormErrorSC>{errors.reinvest_agreement}</AmlFormErrorSC>
                    ) : null}
                  </div>

                  {values.reinvest_agreement ? (
                    <div className="full-block">
                      <SmallText className="smaller bolder input-label">
                        <FormattedMessage
                          id="onboarding_aml_form_reinvest_rate_label"
                          defaultMessage={dlt['onboarding_aml_form_reinvest_rate_label']}
                        />
                      </SmallText>

                      <FormattedMessage
                        id="onboarding_aml_form_reinvest_rate_placeholder"
                        defaultMessage={dlt['onboarding_aml_form_reinvest_rate_placeholder']}
                      >
                        {(placeholder) => (
                          <AmlFormTextInputSC
                            type="number"
                            name="reinvest_rate"
                            placeholder={placeholder}
                            filled={values.reinvest_rate}
                            hasError={reinvestRateHasError}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.reinvest_rate || ''}
                          />
                        )}
                      </FormattedMessage>
                      {reinvestRateHasError ? (
                        <AmlFormErrorSC>{errors.reinvest_rate}</AmlFormErrorSC>
                      ) : null}
                    </div>
                  ) : null}

                  {/*      <div className="full-block">
                  <Checkbox
                    name="consent_to_repurchase_of_receivables"
                    hasError={repurchaseAgreementHasError}
                    value={`${values.consent_to_repurchase_of_receivables}`}
                    checked={values.consent_to_repurchase_of_receivables || false}
                    onChange={handleChange}
                    label="onboarding_aml_form_consent_to_repurchase_of_receivables_label"
                  />
                  {repurchaseAgreementHasError ? (
                    <AmlFormErrorSC>{errors.consent_to_repurchase_of_receivables}</AmlFormErrorSC>
                  ) : null}
                </div> */}
                  <div className="full-block">
                    <SmallText className="smaller bolder input-label">
                      <FormattedMessage
                        id="onboarding_aml_form_max_investment_label"
                        defaultMessage={dlt['onboarding_aml_form_max_investment_label']}
                      />
                      <Tooltip
                        id="aml_max_investment_tooltip"
                        contentId="onboarding_aml_form_max_investment_tooltip"
                      />
                    </SmallText>

                    <FormattedMessage
                      id="onboarding_aml_form_max_investment_placeholder"
                      defaultMessage={dlt['onboarding_aml_form_max_investment_placeholder']}
                    >
                      {(placeholder) => (
                        <AmlFormTextInputSC
                          type="number"
                          name="max_investment"
                          placeholder={placeholder}
                          filled={values.max_investment}
                          hasError={maxInvestmentHasError}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.max_investment || ''}
                        />
                      )}
                    </FormattedMessage>
                    {maxInvestmentHasError ? (
                      <AmlFormErrorSC>{errors.max_investment}</AmlFormErrorSC>
                    ) : null}
                  </div>
                </div>
                <div className="row">
                  <div className="heading-block">
                    <BodyText className="bolder">
                      <FormattedMessage
                        id="onboarding_aml_form_headline_3"
                        defaultMessage={dlt['onboarding_aml_form_headline_3']}
                      />
                    </BodyText>
                    <Tooltip
                      id="aml_heading_tooltip"
                      contentId="onboarding_aml_form_headline_3_tooltip"
                    />
                    <div className="separator"></div>
                  </div>
                  <div className="full-block">
                    <Checkbox
                      name="final_consumer"
                      hasError={finalConsumerHasError}
                      value={`${values.final_consumer}`}
                      checked={values.final_consumer || false}
                      onChange={handleChange}
                      linkSource={finalConsumerPdf}
                      label="onboarding_aml_form_final_consumer_label"
                    />
                    {finalConsumerHasError ? (
                      <AmlFormErrorSC>{errors.final_consumer}</AmlFormErrorSC>
                    ) : null}
                  </div>

                  <div className="full-block">
                    <Checkbox
                      name="politically_exposed"
                      hasError={politicallyExposedHasError}
                      value={`${values.politically_exposed}`}
                      checked={values.politically_exposed || false}
                      onChange={handleChange}
                      linkSource={politicallyExposedPdf}
                      label="onboarding_aml_form_politically_exposed_label"
                    />
                    {politicallyExposedHasError ? (
                      <AmlFormErrorSC>{errors.politically_exposed}</AmlFormErrorSC>
                    ) : null}
                  </div>

                  <div className="full-block">
                    <Checkbox
                      name="sanctioned"
                      hasError={sanctionedHasError}
                      value={`${values.sanctioned}`}
                      checked={values.sanctioned || false}
                      onChange={handleChange}
                      linkSource={sanctionedPdf}
                      label="onboarding_aml_form_sanctioned_label"
                    />
                    {sanctionedHasError ? (
                      <AmlFormErrorSC>{errors.sanctioned}</AmlFormErrorSC>
                    ) : null}
                  </div>

                  <div className="full-block">
                    <Checkbox
                      name="own_interest"
                      hasError={ownInterestHasError}
                      value={`${values.own_interest}`}
                      checked={values.own_interest || false}
                      onChange={handleChange}
                      label="onboarding_aml_form_own_interest_label"
                    />
                    {ownInterestHasError ? (
                      <AmlFormErrorSC>{errors.own_interest}</AmlFormErrorSC>
                    ) : null}
                  </div>

                  <div className="full-block">
                    <Checkbox
                      name="the_purpose_is_to_enhance_funding"
                      hasError={enhanceFundingHasError}
                      value={`${values.the_purpose_is_to_enhance_funding}`}
                      checked={values.the_purpose_is_to_enhance_funding || false}
                      onChange={handleChange}
                      label="onboarding_aml_form_the_purpose_is_to_enhance_funding_label"
                    />
                    {enhanceFundingHasError ? (
                      <AmlFormErrorSC>{errors.the_purpose_is_to_enhance_funding}</AmlFormErrorSC>
                    ) : null}
                  </div>

                  {values.the_purpose_is_to_enhance_funding ? null : (
                    <div className="full-block padded">
                      <SmallText className="smaller bolder input-label">
                        <FormattedMessage
                          id="onboarding_aml_form_the_purpose_is_to_enhance_funding_additional_info_label"
                          defaultMessage={
                            dlt[
                              'onboarding_aml_form_the_purpose_is_to_enhance_funding_additional_info_label'
                            ]
                          }
                        />
                      </SmallText>

                      <FormattedMessage
                        id="onboarding_aml_form_the_purpose_is_to_enhance_funding_additional_info_placeholder"
                        defaultMessage={
                          dlt[
                            'onboarding_aml_form_the_purpose_is_to_enhance_funding_additional_info_placeholder'
                          ]
                        }
                      >
                        {(placeholder) => (
                          <AmlFormTextInputSC
                            type="text"
                            name="the_purpose_is_to_enhance_funding_additional_info"
                            placeholder={placeholder}
                            filled={values.the_purpose_is_to_enhance_funding_additional_info}
                            hasError={purposeEnhanceHasError}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.the_purpose_is_to_enhance_funding_additional_info || ''}
                          />
                        )}
                      </FormattedMessage>
                      {purposeEnhanceHasError ? (
                        <AmlFormErrorSC>
                          {errors.the_purpose_is_to_enhance_funding_additional_info}
                        </AmlFormErrorSC>
                      ) : null}
                    </div>
                  )}
                </div>

                <div className="row">
                  <div className="heading-block">
                    <BodyText className="bolder">
                      <FormattedMessage
                        id="onboarding_aml_form_headline_4"
                        defaultMessage={dlt['onboarding_aml_form_headline_4']}
                      />
                    </BodyText>
                    <div className="separator"></div>
                  </div>

                  <div className="full-block">
                    <Checkbox
                      name="the_funds_do_not_come_from_illegal_sources"
                      hasError={illegalSourcesHasError}
                      value={`${values.the_funds_do_not_come_from_illegal_sources}`}
                      checked={values.the_funds_do_not_come_from_illegal_sources || false}
                      onChange={handleChange}
                      linkSource={'https://www.slov-lex.sk/pravne-predpisy/SK/ZZ/2008/297/20180315'}
                      label="onboarding_aml_form_the_funds_do_not_come_from_illegal_sources_label"
                    />
                    {illegalSourcesHasError ? (
                      <AmlFormErrorSC>
                        {errors.the_funds_do_not_come_from_illegal_sources}
                      </AmlFormErrorSC>
                    ) : null}
                  </div>

                  <div className="full-block">
                    <Checkbox
                      name="agreed_terms"
                      hasError={agreedTermsHasError}
                      value={`${values.agreed_terms}`}
                      checked={values.agreed_terms || false}
                      onChange={handleChange}
                      linkSource={`${process.env.REACT_APP_WISHMAKER_LANDING_URI}/static/pdf/vseobecne_obchodne_podmienky.pdf`}
                      label="onboarding_aml_form_agreed_terms_label"
                    />
                    {agreedTermsHasError ? (
                      <AmlFormErrorSC>{errors.agreed_terms}</AmlFormErrorSC>
                    ) : null}
                  </div>

                  <div className="full-block">
                    <Checkbox
                      name="agreement_with_the_fee_schedule"
                      hasError={agreementWithFeeScheduleHasError}
                      value={`${values.agreement_with_the_fee_schedule}`}
                      checked={values.agreement_with_the_fee_schedule || false}
                      onChange={handleChange}
                      linkSource={`${process.env.REACT_APP_WISHMAKER_LANDING_URI}/static/pdf/sadzobnik_poplatkov.pdf`}
                      label="onboarding_aml_form_agreement_with_the_fee_schedule_label"
                    />
                    {agreementWithFeeScheduleHasError ? (
                      <AmlFormErrorSC>{errors.agreement_with_the_fee_schedule}</AmlFormErrorSC>
                    ) : null}
                  </div>
                </div>

                <div className="row">
                  <div className="full-block">
                    <BodyText>
                      <FormattedHTMLMessage
                        id="onboarding_continue_hint"
                        defaultMessage={dlt['onboarding_continue_hint']}
                      />
                    </BodyText>
                    <Button type="PRIMARY" className="form-submit" onClick={handleSubmit} withIcon>
                      <FormattedMessage
                        id="global_continue"
                        defaultMessage={dlt['global_continue']}
                      />
                    </Button>
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
      </AmlFormSC>
    </>
  );
};

export default AmlForm;
